import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useNotifications from '@lib/hooks/notifications';

import { Slot, If, createPage } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, Loader, Flex, DocumentTitle } = shared;

// import styles from './index.module.scss';
const styles = {};
import { useAuthStore } from '@/stores/auth'; 
import gamesApi from '@/apis/drupal/game';
import checkoutApi from '@/apis/drupal/checkout';
import DeveloperLayout from '@/layouts/DeveloperLayout';
import SpendTokensForm from '@/components/forms/SpendTokensForm';

export default createPage('SpendTokensPage', { styles }, function SpendTokensPage ({ className }) {
  const [ state ] = useAuthStore();
  const router = useRouter();
  const { notify } = useNotifications();

  const [ games, setGames ] = useState([]);
  const [ maxTokens, setMaxTokens ] = useState(0);
  const [ loading, setLoading ] = useState(true);
  
  // Redirect to login if not logged in
  useEffect(() => {
    if (state.ready && !state.auth) {
      router.replace('/');
      return;
    }

    if (state.ready && state.auth) {
      (async () => {
        const games = await gamesApi.listByDeveloperPublishedOnly(state.user.id, 50);
        if (games.error) {
          notify('There was an error fetching the list of your games.');
          setLoading(false);
          return;
        }
        setGames(games);

        const tokenBalance = await checkoutApi.getTokenBalance(state.auth.uid, state.token)
        if (tokenBalance.error) {
          notify('There was an error fetching your balance.');
          setLoading(false);
          return;
        }
        setMaxTokens(tokenBalance.amount);

        setLoading(false);
      })()
    }
  }, [ state ]);

  useEffect(() => {
    if (!window.location.search) return;
    notify('Thank you for your purchase. Your tokens are ready to spend.');
    router.replace(window.location.href.split('?')[0], undefined, { shallow: true });
  }, []);

  return (
    <>
      <DocumentTitle title='Spend Tokens' />

      <DeveloperLayout className={className}>
        {
          If(!state.ready, () => (
            <Loader.Fill large />
          ))
          .ElseIf(state.ready && !!state.auth, () => (
            <Box>
              <Block>
                <Block>
                  <Title>Spend Tokens</Title>
                </Block>
                <Block>
                  {
                    If(loading, () => (
                      <Flex wide tall alignCenter justifyCenter>
                        <Flex><Loader /></Flex>
                      </Flex>
                    ))
                    .Else(() => (
                      <SpendTokensForm
                        uid={state.auth.uid}
                        games={games}
                        maxTokens={maxTokens}
                      />
                    ))
                    .EndIf()
                  }
                </Block>
              </Block>
            </Box>
          ))
          .EndIf()
        } 
      </DeveloperLayout>
    </>
  )
});
